import { render, staticRenderFns } from "./creer-un-site-internet-pour-un-restaurant-exemples-prix-et-delais.vue?vue&type=template&id=6c4191d7&"
import script from "./creer-un-site-internet-pour-un-restaurant-exemples-prix-et-delais.vue?vue&type=script&lang=js&"
export * from "./creer-un-site-internet-pour-un-restaurant-exemples-prix-et-delais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports